import modes from '../mode';

module.exports = function(h, row, that) {
    let mode = modes.find(obj => obj.id == row.mode);

    if (mode != undefined) {
        return mode.name;
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/colums/mode.jsx